import { render, staticRenderFns } from "./HistoryListTransactionLayout.vue?vue&type=template&id=0a2f8baf&scoped=true&"
import script from "./HistoryListTransactionLayout.vue?vue&type=script&lang=js&"
export * from "./HistoryListTransactionLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2f8baf",
  null
  
)

export default component.exports